import { OverlayContainer } from '@angular/cdk/overlay';
import { Location } from '@angular/common';
import { Inject, Injectable, Injector, Optional, Renderer2, SkipSelf } from '@angular/core';
import { MAT_DIALOG_SCROLL_STRATEGY, MatDialog } from '@angular/material';
import { AiDynamicOverlay } from './dynamic-overlay';

// TODO: (prokopenko) don't work correct
@Injectable()
export class AiDynamicMatDialog extends MatDialog {

  private dynamicOverlay: AiDynamicOverlay;

  constructor(overlay: AiDynamicOverlay,
              overlayContainer: OverlayContainer,
              _injector: Injector,
              @Optional() location: Location,
              @Inject(MAT_DIALOG_SCROLL_STRATEGY) _scrollStrategy,
              @Optional() @SkipSelf() _parentDialog: AiDynamicMatDialog) {

    super(overlay, _injector, location, null, _scrollStrategy, _parentDialog, overlayContainer);

    this.dynamicOverlay = overlay;
  }

  public setContainerElement(containerElement: HTMLElement, renderer: Renderer2): void {
    // need to apply this styling to make the backdrop with position: fixed styling cover only the containerElement
    renderer.setStyle(containerElement, 'transform', 'translateZ(0)');

    this.dynamicOverlay.setContainerElement(containerElement);
  }
}
